import React from "react";

import "./EditScriptTab.css";

import { withTranslation } from "react-i18next";
import { Alert, Button, Col, Container, Form, Row } from "react-bootstrap";
import { highlight, languages } from "prismjs/components/prism-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import "prismjs/components/prism-hcl";
import "prismjs/components/prism-clike";
import Editor from "react-simple-code-editor";
import "prismjs/themes/prism.css";
import ValidationHelper from "../../../../helpers/ValidationHelper";

class EditScriptTab extends React.Component {
  constructor(props) {
    super(props);

    this.validationDefinition = {
      script: {
        defaultValue: atob(props.script.script),
        initValid: true,
        rule: ValidationHelper.isNonEmptyString
      }
    };

    this.state = {
      apiError: "",
      dialogApiError: "",
      validation: ValidationHelper.getValidation(this.validationDefinition)
    };

    this.handleChange = this.handleChange.bind(this);
    this.getHiglightingLanguage = this.getHiglightingLanguage.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.refreshValidation = this.refreshValidation.bind(this);
  }

  handleChange(event) {
    this.setState({
      validation: Object.assign(
        {},
        ValidationHelper.update(event, this.state.validation)
      )
    });
  }

  refreshValidation() {
    const validationDefinition = {
      script: {
        defaultValue: atob(this.props.script.script) || "",
        initValid: true,
        rule: ValidationHelper.isNonEmptyString
      }
    };

    this.setState({
      validation: ValidationHelper.getValidation(
        this.props.script ? validationDefinition : this.validationDefinition
      )
    });
  }

  componentDidMount() {
    this.refreshValidation();
  }

  async onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      await this.props.onSubmit(validatedData.script);
      if (!this.props.validationResult) this.refreshValidation();
    }
  }

  getHiglightingLanguage() {
    switch (this.props.highlightingLanguage) {
      case 0:
        return languages.bash;
      default:
        return languages.powershell;
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <Container className="pl-0 pr-0">
          <Row className="mt-3 row">
            <Col className="title-container">
              <h4>{this.props.title}</h4>
            </Col>
            <Col className="d-flex flex-row-reverse">
              <Button
                className="btn btn-green"
                id="submit-btn"
                disabled={
                  !this.state.validation._isValid ||
                  !ValidationHelper.hasChanged(this.state.validation) ||
                  this.props.isSaving
                }
                onClick={() => this.onSubmit()}
              >
                {t("InstanceTemplates.Modal.Form.Submit")}{" "}
                {this.props.isSaving && (
                    <FontAwesomeIcon icon={faCircleNotch} spin />
                )}
              </Button>
            </Col>
          </Row>
          <Row className="mt-3 row">
            {this.props.validationResult && (
              <Col>
                <Alert variant="danger">{this.props.validationResult}</Alert>
              </Col>
            )}
          </Row>
          <Row className="row">
            <Col>
              <div className="container_editor_area">
                <Editor
                  placeholder={t(
                    "SingleScript.EditModal.Form.ScriptPlaceholder"
                  )}
                  value={this.state.validation.script.value}
                  onValueChange={code =>
                    this.handleChange({
                      target: {
                        name: "script",
                        value: code
                      }
                    })
                  }
                  highlight={code =>
                    highlight(code, this.getHiglightingLanguage())
                  }
                  padding={10}
                  className="container__editor"
                />
              </div>
              <Form.Control
                type="hidden"
                isInvalid={!this.state.validation.script.isValid}
              />
              <Form.Control.Feedback type="invalid">
                {t("SingleScript.EditModal.Form.ValidationError.Script")}
              </Form.Control.Feedback>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(EditScriptTab);
